import { useContext } from 'react';
import AppContext from '@context';
import { getJourneyById } from '@services/journeys';
import useLoadJourneyHistory from './useLoadJourneyHistory';

const useLoadJourney = ({ journeyId }: { journeyId: string }) => {
  const { dispatch } = useContext(AppContext);
  const { fetchHistory } = useLoadJourneyHistory({ journeyId });

  const fetchJourney = async () => {
    if (journeyId) {
      dispatch({
        type: 'journeys_selection_fetching',
        payload: { isFetching: true },
      });

      return getJourneyById(journeyId)
        .then((response) => {
          dispatch({
            type: 'journeys_selection_set',
            payload: {
              data: response,
            },
          });
          if (response?.journey?.trucker?.lastLocation.cityName) {
            dispatch({
              type: 'journey_last_location_loaded',
              payload: {
                journeyId,
                description:
                  'Última localização do motorista com data e hora da atualização',
                lastLocation: {
                  city: {
                    name: response.journey.trucker.lastLocation.cityName,
                  },
                  coordinates:
                    response.journey.trucker.lastLocation.coordinates,
                  state: {
                    acronym: response.journey.trucker.lastLocation.stateAcronym,
                  },
                  timestamp: response.journey.trucker.lastLocation.timestamp,
                },
              },
            });
          }

          fetchHistory();
        })
        .catch(() => {
          dispatch({
            type: 'journeys_selection_error',
            payload: { isError: true },
          });
          window.dispatchEvent(
            new CustomEvent('notificationShow', {
              detail: {
                heading: 'Não foi possível realizar esta ação',
                message: 'Tente novamente mais tarde.',
                severity: 'error',
              },
            }),
          );
        });
    }

    return Promise.reject(new Error('journeyCode not found'));
  };

  return { fetchJourney };
};

export default useLoadJourney;
